import React from 'react';
import '../../css/ImageViewer.scss';
import { icons } from '../../assets/extensionIcons';
import { Helmet } from 'react-helmet';
import file from '../../common/file';
import ViewerComponent from './Viewer';
import { supportedFormats as TextViewerFormats } from './TextViewer';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from '@material-ui/core';

const supportedFormats = ([] as string[]).concat(
	icons['fas fa-file-image'],
	icons['fas fa-file-video'],
	icons['fas fa-file-audio'],
	TextViewerFormats
);

interface Props {
	isOpen: boolean;
	setIsOpen: React.Dispatch<boolean>;
	file: file | undefined;
	onEnd: () => void;
}

const PopupViewer: React.FC<Props> = ({ isOpen, setIsOpen, file, onEnd }) => {
	return (
		<Dialog
			open={isOpen}
			onClose={() => setIsOpen(false)}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">{file?.filename}</DialogTitle>
			<DialogContent>
				<Helmet>
					<title>{file !== undefined && file.filename}</title>
				</Helmet>
				{file !== undefined && <ViewerComponent file={file} onEnd={onEnd} />}
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setIsOpen(false)} color="primary" autoFocus>
					close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default PopupViewer;
export { supportedFormats };
